import { router } from "@inertiajs/vue3"
import { shallowRef } from "vue"

import { itemArchivePath } from "@/routes"
import type { ArchiveDispositionInput } from "@/types/models"

export function useItemArchive(itemId: string) {
  const archiveOpen = shallowRef(false)
  const restoreOpen = shallowRef(false)
  const archiving = shallowRef(false)
  const formErrors = shallowRef<Record<string, string>>({})

  function openArchive() {
    formErrors.value = {}
    archiveOpen.value = true
  }

  function confirmArchive(disposition: ArchiveDispositionInput) {
    archiving.value = true
    formErrors.value = {}
    router.patch(
      itemArchivePath(itemId),
      { disposition: { ...disposition } },
      {
        onSuccess: () => (archiveOpen.value = false),
        onError: (errors) => (formErrors.value = errors),
        onFinish: () => (archiving.value = false),
      },
    )
  }

  function confirmRestore() {
    archiving.value = true
    formErrors.value = {}
    router.delete(itemArchivePath(itemId), {
      onSuccess: () => (restoreOpen.value = false),
      onError: (errors) => (formErrors.value = errors),
      onFinish: () => (archiving.value = false),
    })
  }

  return {
    archiveOpen,
    restoreOpen,
    archiving,
    formErrors,
    openArchive,
    confirmArchive,
    confirmRestore,
  }
}
